import React, { useMemo, useState } from "react";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import ProductCard from "../components/site/ProductCard";
import useReveal from "../hooks/useReveal";
import { CATEGORIES } from "../lib/categories";
import { STATIC_PRODUCTS } from "../lib/staticProducts";

const FILTER_TABS = [
    { value: "all", label: "Alle" },
    ...CATEGORIES.filter((c) => c.value !== "buch"),
];

export default function Products() {
    useReveal();
    const [filter, setFilter] = useState("all");

    const items = useMemo(() => {
        const nonBooks = STATIC_PRODUCTS.filter((p) => p.category !== "buch");
        return filter === "all" ? nonBooks : nonBooks.filter((p) => p.category === filter);
    }, [filter]);

    return (
        <main
            data-testid="products-page"
            className="min-h-screen bg-cream-50 text-ink-900 font-sans"
        >
            <Navbar />

            <section className="pt-36 pb-12 md:pt-44 max-w-6xl mx-auto px-6 md:px-10">
                <div className="text-center max-w-2xl mx-auto reveal">
                    <span className="divider-dot mb-6">
                        <span>Sortiment</span>
                    </span>
                    <h1
                        data-testid="products-page-heading"
                        className="font-serif font-light text-5xl md:text-6xl tracking-tight text-ink-900 leading-[1.05]"
                    >
                        Neue <em className="italic text-mauve-500">Ankünfte</em>
                    </h1>
                    <p className="mt-6 text-base md:text-lg text-ink-700 leading-relaxed font-light">
                        Bald erhältliche Notizbücher, Stifte und liebevoll gewählte Geschenke — sichere dir frühzeitig eine Benachrichtigung über WhatsApp.
                    </p>
                </div>

                <div className="mt-12 flex justify-center reveal">
                    <div
                        data-testid="products-filter"
                        className="inline-flex flex-wrap items-center justify-center gap-1 border-b border-cream-300"
                    >
                        {FILTER_TABS.map((t) => (
                            <button
                                key={t.value}
                                data-testid={`filter-${t.value}`}
                                onClick={() => setFilter(t.value)}
                                className={`px-5 py-3 text-[11px] tracking-[0.24em] uppercase font-light border-b-2 transition-colors -mb-px ${
                                    filter === t.value
                                        ? "border-mauve-500 text-ink-900"
                                        : "border-transparent text-ink-500 hover:text-ink-900"
                                }`}
                            >
                                {t.label}
                            </button>
                        ))}
                    </div>
                </div>
            </section>

            <section className="pb-24 max-w-6xl mx-auto px-6 md:px-10">
                <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-10 md:gap-8">
                    {items.map((p) => (
                        <ProductCard key={p.id} product={p} testId={`product-card-${p.id}`} />
                    ))}
                </div>
            </section>

            <Footer />
        </main>
    );
}
